interface ExternalSearchCacheInterface {
  creds: {
    [key: string]: {
      application: string;
      indexName: string;
      token: string;
      expires: number;
    };
  };
  loading: boolean;
}

export const ExternalSearchCache: ExternalSearchCacheInterface = {
  creds: {},
  loading: false
};
